<template>
  <base-section
    id="adress-section"
    heading="Adress"
    :infoStatus="individStore.individ.infoStatus"
    :show-error="!!individStore.individ.error"
  >
    <p v-for="row in formattedAddress" :key="row">
      {{ row }}
    </p>
    <p v-if="!formattedAddress.length">-</p>
  </base-section>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { BaseSection } from "@/components/sections";
import { useIndividStore } from "@/stores";
import { formatPostnummer } from "@/common/formatters";

const individStore = useIndividStore();

const adress = computed(() => individStore.individ.data?.adress);

const zipCodeWithSpace = computed(() => {
  const postnummer = adress.value?.postnummer;
  return postnummer?.length === 5 ? formatPostnummer(postnummer) : postnummer;
});

const formattedAddress = computed(() => {
  return [
    adress.value?.coAdress,
    adress.value?.gatuadress,
    (zipCodeWithSpace.value || "") + " " + (adress.value?.postort || ""),
  ]
    .map((s) => s?.trim())
    .filter((x): x is string => !!x);
});
</script>
